module.exports = __webpack_public_path__ + "static/index/img/register_ico.053d49e9.png";